/*
 * Developed by CQ Inversiones SAS.  Copyright (c) 2024. All rights reserved.
 * Desarrollado por CQ Inversiones SAS.  Copyright (c) 2024. Todos los derechos reservados.
 */

import {AcceptableEnvironmentTypes} from '@shared/types';
import packageInfo from '../../package.json';

export const environment: Record<string, AcceptableEnvironmentTypes> = {
  production: false,
  apiUrl: 'https://io.cqinversiones.co/meerkad-alpha/meerkad/',
  version: packageInfo.version
}
